/* iter-72i — Resume-after-upgrade intent.
 *
 * Small session-scoped helper used by TrialExpiredScreen (write) and
 * AppShell (read). Persists which chapter the user wanted to jump
 * back into so, the instant their trial flips off (via /auth/me
 * refetch after they upgrade), we auto-load that project + chapter
 * and stop bouncing them through the plan-selector.
 *
 * Storage: sessionStorage — cleared automatically when they close the
 * tab (they can always click Resume again from the takeover). Never
 * relies on localStorage; we don't want stale intents leaking across
 * devices.
 */

const KEY = 'pw:resume-after-upgrade';

export function setResumeIntent(projectId, chapterId) {
  if (!projectId) return;
  try {
    window.sessionStorage.setItem(
      KEY,
      JSON.stringify({ project_id: projectId, chapter_id: chapterId || null }),
    );
  } catch (_e) { /* private mode — best effort */ }
}

export function readResumeIntent() {
  try {
    const raw = window.sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.project_id) return null;
    return parsed;
  } catch (_e) {
    return null;
  }
}

export function clearResumeIntent() {
  try { window.sessionStorage.removeItem(KEY); }
  catch (_e) { /* noop */ }
}
